module.exports = __webpack_public_path__ + "img/whitecount_explain.e9765961.png";